export const btnVariant = {
    primary: 'btn-primary',
    default: 'btn-default',
    secondary: 'btn-secondary',
    exercise: 'btn-exercise',
    disabled: 'btn-disabled',
    stress: 'btn-stress',
    outlined: 'outlined',
}

export const btnSize = {
    large: 'btn-large',
    small: 'btn-small',
    middle: 'btn-middle',
}
